import { render, staticRenderFns } from "./ImageContent.vue?vue&type=template&id=1f277e5c&scoped=true"
import script from "./ImageContent.vue?vue&type=script&lang=js"
export * from "./ImageContent.vue?vue&type=script&lang=js"
import style0 from "./ImageContent.vue?vue&type=style&index=0&id=1f277e5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f277e5c",
  null
  
)

export default component.exports